import '../grouped_elements/grouped_elements_select_view.js.coffee'
Monitoring.Views.SocialContents.Filters ||= {}
Monitoring.Views.SocialContents.Filters.GroupedElements ||= {}

class Monitoring.Views.SocialContents.Filters.LabelsFilterGroupView extends Monitoring.Views.SocialContents.Filters.GroupedElementsSelectView

  checkboxClass: ->
    'groups-checkbox-label'

  checkboxLabel: ->
    I18n.t('monitoring.dashboard.filters.exclusion_group')

  comboPlaceholder: ->
    I18n.t('customer.dashboard.filters.placeholders.add_group')

  possibleCustomNames: () ->
    ['allLabels', 'noLabels']

  _swalTitle: () ->
    I18n.t('customer.dashboard.filters.creation.groups.add_warning')
